import { useCallback } from 'react';

const useSmsEditor = (editorRef: React.MutableRefObject<any>) => {
    const insertTagIntoContent = useCallback(
        (currentContent: string, tag: string) => {
            // Get cursor position from editor ref
            const cursorPos = editorRef.current?.getCursorPosition?.() || currentContent.length;

            // Update visual editor
            editorRef.current?.insertAtCursor(tag);

            // Return updated content with tag at cursor position
            return currentContent.slice(0, cursorPos) + tag + currentContent.slice(cursorPos);
        },
        [editorRef]
    );

    return { insertTagIntoContent };
};

export default useSmsEditor;
